// extracted by mini-css-extract-plugin
export default {"button":"Button_button__P5SL9","buttonInner":"Button_buttonInner__yI1IK"};